import { INotification } from "Model/State/INotification";
import { IState } from "Model/State/IState";

export function selectNotifications(state: IState): INotification[] {
  return state.ui.notification.notifications;
}
